export const featureFlags = {
  waitUntilLoaded: async () => {},
  getVariant: () => 'pro',
  getVariantAsync: async () => 'pro',
  isOn: () => false,
  isOnAsync: async () => false,
  isEnabled: () => false,
  isEnabledAsync: async () => false,
}

export default featureFlags
